import React from 'react'
import '../App.css'
import Bodyhomeadmin from './bodyhomeadmin'
export class Bodyapphomebodyadmin extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyhomeadmin />
                </div>
            </div>
        );
    }
}